function launchMilestoneConfetti({ x, y, colors }) {
    const canvas = document.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.left = '0';
    canvas.style.top = '0';
    canvas.style.width = '100vw';
    canvas.style.height = '100vh';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '10000';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    const particleCount = 160;
    const particles = Array.from({ length: particleCount }).map(() => {
        // Mostly-upward fountain spread with some full-circle drift for volume.
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.6;
        const speed = 2.5 + Math.random() * 4.5;
        const shape = Math.random() > 0.5 ? 'rect' : 'circle';
        return {
            x,
            y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            size: 5 + Math.random() * 6,
            color: colors[Math.floor(Math.random() * colors.length)],
            shape,
            rotation: Math.random() * 360,
            rotationSpeed: (Math.random() - 0.5) * 10,
            gravity: 0.09 + Math.random() * 0.08,
            drag: 0.985 + Math.random() * 0.01,
            life: 0,
            maxLife: 150 + Math.random() * 60,
        };
    });

    const handleResize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', handleResize);

    function frame() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let alive = false;
        particles.forEach((p) => {
            if (p.life >= p.maxLife) return;
            alive = true;
            p.life += 1;
            p.vy += p.gravity;
            p.vx *= p.drag;
            p.x += p.vx;
            p.y += p.vy;
            p.rotation += p.rotationSpeed;
            const opacity = Math.max(0, 1 - p.life / p.maxLife);
            ctx.save();
            ctx.globalAlpha = opacity;
            ctx.translate(p.x, p.y);
            ctx.rotate((p.rotation * Math.PI) / 180);
            ctx.fillStyle = p.color;
            if (p.shape === 'circle') {
                ctx.beginPath();
                ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
                ctx.fill();
            } else {
                ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
            }
            ctx.restore();
        });

        if (alive) {
            requestAnimationFrame(frame);
        } else {
            window.removeEventListener('resize', handleResize);
            canvas.remove();
        }
    }

    requestAnimationFrame(frame);
}

class MilestoneOfferBar extends HTMLElement {
    escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
    }

    parseJsonAttribute(name, fallback) {
        try {
            const raw = this.getAttribute(name);
            return raw ? JSON.parse(raw) : fallback;
        } catch (error) {
            return fallback;
        }
    }

    connectedCallback() {
        this.cartTotal = Number(this.getAttribute('total-price')) || 0;
        this.allCompleteMessage = this.getAttribute('all-complete-message') || '';
        this.confettiEnabled = this.hasAttribute('confetti');
        this.storageKey = this.getAttribute('storage-key') || 'milestone-offer-bar';

        const currencyRate = parseFloat(
            (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1
        );

        const rawMilestones = this.parseJsonAttribute('milestones', []);
        this.milestones = rawMilestones
            .filter((milestone) => milestone && typeof milestone.amount === 'number')
            .map((milestone) => ({
                ...milestone,
                finalAmount: milestone.amount * currencyRate,
            }))
            .sort((a, b) => a.finalAmount - b.finalAmount);

        const confettiColors = this.parseJsonAttribute('confetti-colors', []);
        this.confettiColors = confettiColors.length
            ? confettiColors
            : ['#FFC700', '#FF3D71', '#00D68F', '#0095FF'];

        if (!this.milestones.length) {
            this.hidden = true;
            return;
        }

        this.hidden = false;
        this.build();
        this.render(false);
    }

    build() {
        if (this.querySelector('[milestone-track]')) return;

        this.innerHTML = `
      <p class="milestone-offer-bar__message" milestone-message></p>
      <div class="milestone-offer-bar__content">
        <div class="milestone-offer-bar__track-area" milestone-track-area>
          <div class="milestone-offer-bar__track" milestone-track>
            <span class="milestone-offer-bar__fill" milestone-fill></span>
          </div>
        </div>
      </div>
    `;

        const trackArea = this.querySelector('[milestone-track-area]');
        const maxAmount = this.milestones[this.milestones.length - 1].finalAmount;
        // Keep marker centers inset from the edges so their label/icon never clip
        // outside the drawer and force a horizontal scrollbar. Roughly half the
        // marker width, matching the CSS breakpoint marker sizes.
        const edgeInsetPx = window.innerWidth <= 480 ? 26 : 36;

        this.milestones.forEach((milestone, index) => {
            const marker = document.createElement('div');
            marker.className = 'milestone-offer-bar__marker';
            marker.setAttribute('data-index', String(index));
            marker.setAttribute('title', milestone.label || '');
            const pct = maxAmount > 0 ? milestone.finalAmount / maxAmount : 1;
            marker.style.left = `calc(${edgeInsetPx}px + (100% - ${edgeInsetPx * 2}px) * ${pct})`;
            marker.innerHTML = `
        <span class="milestone-offer-bar__icon">
          ${milestone.iconSvg || ''}
          <span class="milestone-offer-bar__check" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="9" height="9"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12l5 5L19 7"/></svg>
          </span>
        </span>
        <span class="milestone-offer-bar__label">${this.escapeHtml(milestone.label)}</span>
      `;
            trackArea.appendChild(marker);
        });

        this.fillEl = this.querySelector('[milestone-fill]');
        this.messageEl = this.querySelector('[milestone-message]');
        this.markerEls = Array.from(this.querySelectorAll('.milestone-offer-bar__marker'));
    }

    getMaxAmount() {
        return this.milestones[this.milestones.length - 1].finalAmount;
    }

    getProgressWidth() {
        const max = this.getMaxAmount();
        if (max <= 0) return 100;
        if (this.cartTotal <= 0) return 0;
        return Math.min(100, (this.cartTotal / max) * 100);
    }

    getMessageParts() {
        const next = this.milestones.find((milestone) => this.cartTotal < milestone.finalAmount);
        if (!next) {
            return { complete: true, text: this.allCompleteMessage };
        }
        const remaining = next.finalAmount - this.cartTotal;
        const formatted = Shopify.formatMoney(remaining, Shopify.money_format);
        const template = next.message || '';
        const segments = template.split(/\{\{\s*pending_amount\s*\}\}/);
        return {
            complete: false,
            before: segments[0] || '',
            amount: segments.length > 1 ? formatted : '',
            after: segments.length > 1 ? segments[1] : '',
        };
    }

    renderMessage() {
        const parts = this.getMessageParts();
        this.messageEl.classList.remove('is-flash');
        if (parts.complete) {
            this.messageEl.textContent = parts.text;
            return;
        }
        this.messageEl.innerHTML = `${this.escapeHtml(parts.before)}<strong class="milestone-offer-bar__amount">${this.escapeHtml(
            parts.amount
        )}</strong>${this.escapeHtml(parts.after)}`;
    }

    showUnlockFlash(milestone) {
        if (!milestone) {
            this.renderMessage();
            return;
        }
        clearTimeout(this._flashTimer);
        this.messageEl.textContent = milestone.completedMessage || milestone.label || '';
        this.messageEl.classList.add('is-flash');
        this._flashTimer = setTimeout(() => {
            this.renderMessage();
        }, 2200);
    }

    getReachedAmounts() {
        return this.milestones
            .filter((milestone) => this.cartTotal >= milestone.finalAmount)
            .map((milestone) => milestone.finalAmount);
    }

    loadCelebrated() {
        try {
            const raw = sessionStorage.getItem(this.storageKey);
            return raw ? JSON.parse(raw) : [];
        } catch (error) {
            return [];
        }
    }

    saveCelebrated(list) {
        try {
            sessionStorage.setItem(this.storageKey, JSON.stringify(list));
        } catch (error) {
            // Ignore storage failures (private browsing, quota, etc).
        }
    }

    celebrate() {
        if (!this.confettiEnabled) return;
        const rect = this.getBoundingClientRect();
        launchMilestoneConfetti({
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
            colors: this.confettiColors,
        });
    }

    render(detectNewMilestones) {
        if (!this.messageEl) return;

        const width = this.getProgressWidth();
        this.fillEl.style.setProperty('--bar-width', `${width}%`);

        if (this._hasRendered) {
            const currentWidth = getComputedStyle(this.fillEl).width;
            this.fillEl.style.animation = 'none';
            this.fillEl.style.width = currentWidth;
            void this.fillEl.offsetHeight;
            this.fillEl.style.width = `${width}%`;
        }
        this._hasRendered = true;

        const reached = this.getReachedAmounts();
        const celebrated = this.loadCelebrated();
        const newlyReached = reached.filter((amount) => !celebrated.includes(amount));

        this.markerEls.forEach((marker, index) => {
            const milestone = this.milestones[index];
            const isReached = reached.includes(milestone.finalAmount);
            marker.classList.toggle('reached', isReached);
            marker.classList.toggle(
                'just-reached',
                detectNewMilestones && newlyReached.includes(milestone.finalAmount)
            );
        });

        if (detectNewMilestones && newlyReached.length) {
            const lastMilestone = this.milestones.find(
                (milestone) => milestone.finalAmount === newlyReached[newlyReached.length - 1]
            );
            this.showUnlockFlash(lastMilestone);
            this.celebrate();
        } else {
            this.renderMessage();
        }

        this.saveCelebrated(reached);
    }

    updateTotal(newTotal) {
        this.cartTotal = newTotal;
        this.render(true);
    }
}

customElements.get('milestone-offer-bar') ||
    customElements.define('milestone-offer-bar', MilestoneOfferBar);
